import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { PublicOperationsServiceService } from '../public-operations-service/public-operations.service';

@Component({
  selector: 'app-public-operation-handshake',
  templateUrl: './public-operation-handshake.component.html',
  styleUrls: ['./public-operation-handshake.component.css']
})
export class PublicOperationHandshakeComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private operationService: PublicOperationsServiceService,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      if (token) {
        this.authService.removeToken();
        this.operationService.setToken(token);

        setTimeout(() => {
          this.router.navigate(['/public/operations']);
          // window.history.replaceState({}, document.title, window.location.pathname);
        }, 5000);
      }
    });
  }

}
